<template>
  <v-dialog v-model="showUsersManagerDialog" width="100%" :max-width="maxWidth">
    <v-card>
      <v-app-bar color="eef2f6">
        <v-toolbar-title class="headline"> {{ dialogTitle }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <button
          type="button"
          class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
          @click="showUsersManagerDialog = false"
        >
          <i class="fal fa-times" />
        </button>
      </v-app-bar>
      <div>
        <div class="d-flex justify-end ma-3 mr-4" v-if="isTable">
          <v-btn
            class="primaryMainText--text"
            color="primaryMain"
            dark
            @click="switchSection()"
          >
            <i :class="btnIcon" style="line-height: 1px" class="mr-2" />
            Create User
          </v-btn>
        </div>
        <div>
          <v-alert
            v-if="showError"
            dense
            outlined
            type="error"
            class="body-2 mx-3"
          >
            {{ error }}
          </v-alert>
        </div>
        <div v-if="isTable" class="ma-3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            class="ma-2"
            hide-details
            @keyup="renderSearch"
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1 ma-2"
            :loading="loading"
            loading-text="Loading... Please wait"
            :options.sync="options"
            :server-items-length="pagination.total"
            :items-per-page="pagination.per_page"
            :footer-props="{ disablePagination: paginationDisable }"
          >
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="gotoView(item)"
                    x-small
                    icon
                    class="mx-1"
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                  >
                    <v-icon small>fa fa-user-circle</v-icon>
                  </v-btn>
                </template>
                <span>View User's Details</span>
              </v-tooltip>

              <v-tooltip bottom v-if="show">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="selectUser(item)"
                    x-small
                    icon
                    class="mx-1"
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                  >
                    <v-icon small>fa fa-eye</v-icon>
                  </v-btn>
                </template>
                <span>Select User to view Overview Report</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
        <div v-if="!isTable" class="ma-3">
          <users-manager-create
            @changeInput="changeInput"
          ></users-manager-create>
        </div>
        <div v-else></div>
      </div>
      <v-card-actions>
        <div
          class="d-flex flex-2xl-row flex-xl-row flex-lg-row flex-md-row flex-column w-100"
          :class="isTable ? 'justify-end' : 'justify-content-between'"
        >
          <div class="d-flex justify-start" v-if="!isTable">
            <v-btn text @click="switchSection()">
              <v-icon x-small class="mr-2">fa fa-arrow-left</v-icon>
              Back to users list
            </v-btn>
          </div>

          <div class="d-flex">
            <v-btn
              color="red lighten-1"
              dark
              outlined
              @click="showUsersManagerDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              :loading="inputLoading"
              v-if="!isTable"
              class="primaryMainText--text"
              color="primaryMain"
              @click="store()"
            >
              Save
            </v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UsersManagerCreate from './UsersManagerCreate';

export default {
  name: 'UsersManagerDialog',
  props: {
    value: Boolean,
    show: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    UsersManagerCreate,
  },
  data() {
    return {
      inputLoading: false,
      loading: false,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Number', value: 'phone_number' },
        { text: 'Action', value: 'action' },
      ],
      items: [],
      search: '',
      pagination: {
        total: 1,
        per_page: 10,
        current_page: 1,
        search: '',
        sortBy: '',
        sortDesc: false,
      },
      options: {},
      paginationDisable: false,
      timeout: null,
      isTable: true,
      btnTitle: 'Create User',
      btnIcon: 'fa fa-user-plus',
      dialogTitle: 'Users',
      userForm: {},
      maxWidth: '1000',
      showError: false,
      error: '',
    };
  },

  computed: {
    showUsersManagerDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    options: {
      handler() {
        this.changeTable();
      },
      deep: true,
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    renderSearch() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.options.page = 1;
        this.changeTable();
      }, 1000);
    },
    fetch() {
      this.loading = true;
      this.paginationDisable = true;
      this.items = [];
      this.$http
        .get('central/get-users', {
          params: {
            per_page: this.pagination.per_page,
            current_page: this.pagination.current_page,
            sortBy: this.pagination.sortBy,
            sortDesc: this.pagination.sortDesc,
            search: this.search,
          },
        })
        .then((data) => {
          this.loading = false;
          this.items = data.data.data;
          this.pagination.total = data.data.total;
          this.pagination.current_page = data.data.current_page;
          this.pagination.per_page = data.data.per_page;
          this.paginationDisable = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log('Something went wrong!');
        });
    },
    changeTable() {
      this.pagination.current_page = this.options.page;
      this.pagination.sortBy =
        this.options.sortBy !== undefined ? this.options.sortBy[0] : '';
      this.pagination.sortDesc =
        this.options.sortDesc !== undefined ? this.options.sortDesc[0] : '';
      this.fetch();
    },
    changeInput(value) {
      this.userForm = value;
    },
    store() {
      this.inputLoading = true;
      this.$http
        .post('/central/store/user', this.userForm)
        .then((result) => {
          this.inputLoading = false;
          this.page = 1;
          this.$notify('success', 'User Added!');
          this.switchSection();
        })
        .catch((errors) => {
          if (errors.response.status == '422') {
            this.showError = true;
            this.error = errors.response.data.errors;
            this.inputLoading = false;

            this.$notify('error', this.error);
          }
        });
    },
    switchSection() {
      this.isTable = !this.isTable;
      if (this.isTable) {
        this.maxWidth = '1000';
        this.dialogTitle = 'Users List';
      } else {
        this.maxWidth = '500';
        this.dialogTitle = 'Create User';
      }
    },
    gotoView(item) {
      window.open(`/central/user/${item.central_id}`, '_blank');
    },
    selectUser(item) {
      let value = [
        {
          id: item.id,
          name: item.name,
        },
      ];

      this.$store.dispatch('overviewReport/setUsersFilter', value);
      this.showUsersManagerDialog = false;

      this.$emit('selectUser', value);
    },
  },
};
</script>
